<template>
  <div class="hll-popup-center-main" :class="{'hll-popup-center-on': isShow}">
    <div class="hll-popup-center-inner">
      <div @click="close" class="hll-popup-close-icon-box">
        <i class="hll-popup-close-icon"></i>
      </div>
      <section class="hll-success-save-box">
        <div class="hll-save-img">
          <!-- <img
            v-if="openImgType === 'home'"
            @click="saveImg('home')"
            saveImg
            src="https://charter.huolala.cn/h5/cdn/img/202003-backups/hint-bg-driver.png"
            alt=""
          >
          <img
            v-else
            @click="saveImg('signIn')"
            saveImg
            src="https://charter.huolala.cn/h5/cdn/img/202003-backups/hint-bg-driver.png"
            alt=""
          > -->
          <img
            @click="saveImg()"
            saveImg
            src="https://charter.huolala.cn/h5/cdn/img/202003-backups/hint-bg-driver.png"
            alt=""
          >
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { toSaveImg } from "@/utils/hllApp";
export default {
  data() {
    return {
      isShow: false,
      openImgType: "signIn" // home: 首页图，signIn: 签到抽奖图
    };
  },
  methods: {
    close() {
      this.isShow = false;
    },
    open(payload) {
      // this.openImgType = payload;
      this.isShow = true;
    },
    saveImg(saveType) {
      toSaveImg("https://charter.huolala.cn/h5/cdn/img/202003-backups/hint-bg-driver.png");
      // if (saveType === "home") {
      //   // 保存类型  home: 首页
      //   toSaveImg(
      //     "https://charter.huolala.cn/h5/cdn/img/202003-backups/hint-bg-driver.png"
      //   );
      // } else {
      //   toSaveImg(
      //     "https://charter.huolala.cn/h5/cdn/img/12-v3/success-save-bg.png"
      //   );
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
// 剧中弹窗
.hll-popup-center-main {
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  transform: translateY(100%);
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  &.hll-popup-center-on {
    background-color: rgba(0, 0, 0, 0.7);
    visibility: visible;
    transform: translateY(0);
  }
  .hll-popup-center-inner {
    position: relative;
  }
  .hll-save-img {
    text-align: center;
    img {
      width: 80%;
    }
  }
  .hll-popup-close-icon-box {
    position: absolute;
    top: rpx(-100);
    right: 10%;
    width: rpx(40);
    height: rpx(40);
    z-index: 100;
    .hll-popup-close-icon {
      position: absolute;
      width: rpx(40);
      height: rpx(40);
      background: url("~@/assets/img/close.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
